/*
 * @Author: Ashley.Liu
 * @Date: 2022-12-23 15:29:36
 * @LastEditTime: 2023-02-07 10:20:06
 * @Description: desc
 */
import { toUniversalFormat } from '@/utils/dateutils'
import dayjs from 'dayjs'

export default {
  install(Vue, options) {
    Vue.prototype.$isNotEmpty = function (text) {
      return text !== undefined && text !== null && text !== ''
    }
    Vue.prototype.$isEmpty = function (text) {
      return text === undefined || text === null || text === ''
    }
    Vue.prototype.$isNotNull = function (obj) {
      return obj !== undefined && obj !== null
    }
    Vue.prototype.$isNull = function (obj) {
      return obj === undefined || obj === null
    }
    Vue.prototype._toDateString = function (date) {
      return toUniversalFormat(date)
    }
    Vue.prototype._isEmptyString = function (text) {
      return text === undefined || text === null || text === ''
    }
    Vue.prototype._isNotEmptyString = function (text) {
      return !this._isEmptyString(text)
    }
    Vue.prototype._isNotNull = function (obj) {
      return obj !== undefined && obj !== null
    }
    Vue.prototype._isNull = function (obj) {
      return !this._isNotNull(obj)
    }

    const timeSystemFormat = (timeVal, format) => {
      return dayjs(timeVal).format(format || 'MMM D, YYYY, hh:mm:ss A')
    }
    Vue.filter('timeSystemFormat', timeSystemFormat)
    Vue.prototype.$timeSystemFormat = timeSystemFormat
  }
}
